<template>
	<div>
		<a-upload ref="upload" :action="url" :headers="headers" :name="data.name" :remove="removeFile" :multiple="true" @preview="previewFile"
		 :data="upInfo" method="post" :beforeUpload="beforeUpload" @change="handleChange">
			<a-button>
				<a-icon type="upload" /> 上传文件 </a-button>
				
		</a-upload>
		<div v-if="typeIndex == 1" style="margin-top: 10px;">仅支持扩展名：.pdf/.ofd/.jpg/.png文件</div>
		<div v-else-if="type == 1" style="margin-top: 10px;color: red;">请上传招标公告/招标文件</div>
		<span style="color: red;margin-top: 10px;" v-else>上传的附件若含有敏感信息请自行加密后再上传</span>
	</div>
</template>
<script>
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	import storage from 'store'
	import {
		file_del_java,
		previewFileById
	} from '@/api/activiti'
	import {
	axios
} from '@/utils/request'
	export default {
		data() {
			return {
				headers: {},
				upInfo: null,
				fileList: [],
				url: process.env.VUE_APP_API_BASE_URL + "/file/file/upload"
			}
		},
		props: {
			data: {
				type: Object,
				default: true,
			},
			typeIndex: {
				type: Number,
				default: false,

			},
			type: {
				type: Number,
				default: false,
			}
		},
		watch: {
			data(val, old) {
				console.log(val, old)
			},
		},
		methods: {
			//删除文件
			removeFile(file) {
				let data = file.response.data + ',' + file.name
				this.fileList.forEach((item, idx) => {
					if (item == data) {
						this.fileList.splice(idx, 1)
				        console.log(file,this.fileList, 'file=================')
					}
				})
				file_del_java({
					types:this.data.type,
					path:file.response.data.url[0].path
				}).then(res=>{
					// console.log(file.response, 'file=================')
					// this.$emit('getList',file.response.data.url)
					this.$message.success('删除成功')
				})
			},
			//预览文件
			previewFile(file) {
				// console.log(file, 'file=========================')
				// 		let fileIdData = new FormData()
			    //     fileIdData.append('id', file.id)
				// let path = '/' + file.response.data.url[0].path.split('/')[0] + '/'
				// let fileName = file.response.data.url[0].path.substring(file.response.data.url[0].path.indexOf("/")+1)
				// axios({
				// 	url: `/file/file/download?bucketName=${this.data.type}&path=${path}&fileName=${fileName}`,
				// 	method: 'post',
				// 	responseType: 'blob', // 必须要写
				// 	// headers: {
				// 	// 	'Content-Type': 'application/json;charset=UTF-8'
				// 	// }
				// }).then((res)=>{
				// 	console.log(res,111111);
				// 	 window.open(res) //新窗口打开，借用浏览器去打印
				// })
				// // 预览接口调用
				// previewFileById({
				// 	bucketName: this.data.type,
				// 	path: '/' + file.response.data.url[0].path.split('/')[0] + '/',	
				// 	fileName: file.response.data.url[0].path.substring(file.response.data.url[0].path.indexOf("/")+1)
				// }).then((res) => {
				// 	console.log(res, 'res')
				// 	// const blob = new Blob([res.data], { type: 'application/pdf' })
				// 	// this.pdfSrc = window.URL.createObjectURL(blob)
				// 	// window.open(this.pdfSrc) //新窗口打开，借用浏览器去打印
				// })
				// window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
				window.open(file.response.data.url[0].url)
			},
			// 上传各式限制
			beforeUpload(file) {
				console.log(file,'file====================')
				const tok = storage.get(ACCESS_TOKEN)
				this.headers = {
					token: tok,
				}
				this.upInfo = {
					types: this.data.type,
					tempId: this.data.code,
					delFlag: 2,
					path: 'company' + this.$store.state.user.info.deptId + '/',
				}
				var isType = true
				const isLt2M = file.size / 1024 / 1024 < 30
				if (!isLt2M) {
					this.$message.error('上传文件大小不能超过 30MB!')
					this.removeFile(file)
				}
					if(this.typeIndex == 1) {
					console.log(file, 'file111111111111111111111============================')
					if (file.type.indexOf('/pdf') == -1  && file.type.indexOf('/ofd') == -1 && file.type.indexOf('/jpg') == -1 && file.type.indexOf('/png') == -1 && file.type.indexOf('/jpeg') == -1) {
						this.$message.error("仅支持上传.pdf/.ofd/.jpg/.png格式的文件");
						// var index = file.fileList.length - 1
						// file.fileList.splice(index, 1)
						}
				    return 
				}
			
				// if (this.data.types.indexOf(file.type) == -1) {
				// 	isType = false
				// 	this.$message.error('只能上传' + this.data.types.join(',') + '文件')
				// }
				return isLt2M && isType
			},
			//上传文件
			handleChange(info) {
				if(this.typeIndex == 1) {
					if (info.file.type.indexOf('/pdf') == -1  && info.file.type.indexOf('/ofd') == -1 && info.file.type.indexOf('/jpg') == -1 && info.file.type.indexOf('/png') == -1  && info.file.type.indexOf('/jpeg') == -1) {
					var index = info.fileList.length - 1
					info.fileList.splice(index, 1)
					return
					}

				}
				this.$emit('getList',{
					type: 'file',
					arr: info.fileList
				})
				console.log(info, 'info=====================')
			
				// info.fileList.forEach((item, idx) => {
				// 	if (this.data.types.indexOf(item.type) == -1) {
				// 		info.fileList.splice(idx, 1)
				// 	}
				// })
				if (info.file.status !== 'uploading') {
					// info.fileList.splice(info.fileList.length - 1, 1)
				}
				if (info.file.status === 'done') {
					if (info.file.response.code != 200) {
						info.fileList.forEach((item, idx) => {
							if (item.uid == info.file.uid) {
								info.fileList.splice(idx, 1)
							}
						})
						this.$message.error(info.file.response.msg)
						return
					}
					if(this.typeIndex == 1){
						if(info.fileList.length > 1) {
							this.$message.warning('只能上一份文件！')
							info.fileList.splice(1, 1)
							return
						}
						console.log(info.file.response.data.url[0].id, 'info===================')
						this.$emit('getBillAttach', info.file.response.data.url)
					}
					this.$message.success('上传成功')
					this.fileList.push(info.file.response.data.url[0].path)
				} else if (info.file.status === 'error') {
					info.fileList.forEach((item, idx) => {
						if (item.uid == info.file.uid) {
							info.fileList.splice(idx, 1)
						}
					})
					this.$message.error('上传失败')
				}
			},
		},
	}
</script>
<style>
	.ant-upload-list-item-info {
		color: #00A2FD;
	}
</style>
